<template>
  <tag-select
    v-model="selectedTags"
    document-id="assets"
    :hide-details="false"
    :get-tags-function="getAssetTags"
    :organization-id="organizationId"
    :hidden-tag-ids="hiddenTagIds"
    :label="$t('assets.field.tags')"
  />
</template>

<script setup lang="ts">
const { getAssetTags } = useAssetTagStore()

const selectedTags = defineModel<Array<AssetTag>>({ default: () => [] })

const { hiddenTagIds = [], organizationId = undefined } = defineProps<{
  hiddenTagIds?: Array<string>
  organizationId?: string
}>()
</script>
